module.exports = __webpack_public_path__ + "images/dataNotFound_0d89485.svg";